import axiosInstance from "./AxiosInstance";

const BASE_URL = "/api/v3/zonas-sociales/activos/programaciones/";

export const ProgramacionMantenimientoService = {
  listar: (params = {}) => axiosInstance.get(BASE_URL, { params }),

  obtener: (uuid) => axiosInstance.get(`${BASE_URL}${uuid}/`),

  crear: (data) => axiosInstance.post(BASE_URL, data),

  actualizar: (uuid, data) => axiosInstance.patch(`${BASE_URL}${uuid}/`, data),

  eliminar: (uuid) => axiosInstance.delete(`${BASE_URL}${uuid}/`),

  exportar: () =>
    axiosInstance({
      url: `${BASE_URL}exportar/`,
      method: "GET",
      responseType: "blob",
    }),
};

export default ProgramacionMantenimientoService;
